var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"card",attrs:{"body-style":{
  padding: '0px',
  position: 'relative',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'nowrap',
  justifyContent: 'space-between'
}}},[(_vm.burst)?_c('div',{staticClass:"card-burst"},[_c('span',{staticClass:"card-burst-text",domProps:{"innerHTML":_vm._s(_vm.burst)}})]):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"card-image-container",style:({ backgroundImage: `url(${_vm.image})` })}),_vm._v(" "),_c('div',{staticClass:"card-text"},[_c('p',{staticClass:"card-subhead"},[_vm._v(_vm._s(_vm.subhead))]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.headline))]),_vm._v(" "),_c('div',{staticClass:"card-blurb",domProps:{"innerHTML":_vm._s(_vm.copy)}})])]),_vm._v(" "),(_vm.hasLink)?_c('div',{staticClass:"card-link"},[_c('a',{staticClass:"arrow",attrs:{"href":_vm.linkUrl}},[_vm._v("\n      "+_vm._s(_vm.linkText)+"\n    ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }